import {
  SEARCH_REQUEST,
  SEARCH_SUCCESS,
  SEARCH_FILTERS_SET,
  SEARCH_DATES_SET,
  SEARCH_RESET,
  FILTER_PAYLOAD,
  CLEAR_FILTER_PAYLOAD,
  CUSTOM_SEARCH_SUCCESS,
  CUSTOM_SEARCH_REQUEST,
  CUSTOM_SEARCH_RESET,
  CUSTOM_SEARCH_FILTER_DATA
} from './types';

const initialState = {
  isPending: false,
  movies: [],
  filters: {
    technologies: [],
    versions: []
  },
  searchData: {},
  latestRequestId: null,
  dates: [],
  filterPayload: {},
  customSearchData: [],
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case SEARCH_REQUEST: {
      return {
        ...state,
        isPending: true
      };
    }

    case SEARCH_SUCCESS: {
      return {
        ...state,
        isPending: false,
        movies: payload.movies
      };
    }

    case SEARCH_FILTERS_SET: {
      return {
        ...state,
        filters: payload.filters
      };
    }

    case CUSTOM_SEARCH_REQUEST: {
      return {
        ...state,
        isPending: true,
        latestRequestId: payload.requestId
      };
    }
    case CUSTOM_SEARCH_SUCCESS: {
      if(payload.requestId !== state.latestRequestId) return state;
      return {
        ...state,
        isPending: false,
        searchData: payload.searchData
      };
    }

    case SEARCH_DATES_SET: {
      return {
        ...state,
        isPending: false,
        dates: payload.dates
      };
    }

    case SEARCH_RESET: {
      return {
        ...state,
        isPending: false,
        movies: [],
      };
    }

    case CUSTOM_SEARCH_RESET: {
      return {
        ...state,
        isPending: false,
        searchData: "Data is Empty"
      };
    }

    case CUSTOM_SEARCH_FILTER_DATA: {
      return {
        ...state,
        // isPending: false,
        customSearchData: payload.customSearchData || [],
      };
      // if(payload.requestId !== state.latestRequestId) return state;
      // return {
      // ...state,
      //   isPending: false,
      //   searchData: payload.searchData
      // };
    }
    case FILTER_PAYLOAD: {
      return {
        ...state,
        filterPayload: payload
      };
    }
    case CLEAR_FILTER_PAYLOAD: {
      return {
        ...state,
        isPending: false,
        filterPayload: {}
      };
    }

    default: {
      return state;
    }
  }
}
